import React, { useState, useEffect } from 'react'
import User from './../Public/Image/Profile/Person.svg'
import Coin from './../Public/Image/BuyCoin/Coin.svg'
import Snackbar from '@mui/material/Snackbar';
import ContentCopyIcon from '@mui/icons-material/ContentCopy';
import moment from 'moment';
import thumb_upList from '../Public/Image/Home/React/reacticon.png'
import { GameDB } from '../DataBase/GameDB'

const PaymentReact = ({ item }) => {
  const [state, setState] = React.useState({
    opens: false,
    vertical: 'top',
    horizontal: 'center',
  });
  const { vertical, horizontal, opens } = state;
  const handleClick = (newState) => {
    setState({ ...newState, opens: true });
  };
  const handleClose = () => {
    setState({ ...state, opens: false });
  };
  const copyText = async (value) => {

    try {
      await navigator.clipboard.writeText(value);
      handleClick({ vertical: 'bottom', horizontal: 'center' })
    } catch (err) {
      console.error('Unable to copy text to clipboard', err);
    }
  }
  const [EmojiItem, setEmojiItem] = useState('')
  const GetAppSetting = async () => {
    let AppSetting = await GameDB.AppSetting.toArray()
    // console.log(AppSetting[0].AppSetting.emojiList)
    const emojiList = AppSetting[0].AppSetting.emojiList
    // console.log(emojiList)
    // console.log(item)
    let Emoj = emojiList.find(item1 => item1.emoji === item.emoji);
    // console.log(Emoj)
    setEmojiItem(Emoj)
    // Emoji
  }
  useEffect(() => {
    GetAppSetting()
  }, [])
  // useEffect(() => {
  //   console.log(EmojiItem)
  // }, [EmojiItem])
  return (
    <div className='PaymrntItem'>

      <div className='PaymentItemRow'>
        <div className='PaymentKey'>Product</div>
        <div className='PaymentValue' style={{ "display": "flex", flexDirection: "row", justifyContent: "space-between", alignItems: "center" }}>
          {parseInt(item.view_count).toLocaleString() + "  "}
          {EmojiItem ? <img src={EmojiItem?.image} width={20} height={20} style={{ marginLeft: '8px' }} /> : item.emoji}
        </div>
      </div>
  {item.status == "pending" ?
        <div className='PaymentItemRow'>
          <div className='PaymentKey' style={{color:'#E4A020'}}>Payment status</div>
          <div className='PaymentValue'>{item.status} </div>
        </div>
        : null
      }
      <div className='PaymentItemRow'>
        <div className='PaymentKey'>Price</div>
        <div className='PaymentValue'>{item.price} {item.market == 'zarinpal' ? 'T' : '$'} </div>
      </div>

      {/* <div className='PaymentItemRow'>
      <div className='PaymentKey'>Amount</div>
      <div className='PaymentValue'>8,000 $</div>
    </div> */}

      <div className='PaymentItemRow'>
        <div className='PaymentKey'>Date</div>
        <div className='PaymentValue Date'>
          <span className='DateText'>
            {/* {item.date}  */}
            {
              // item.date
              moment(item.dateTime).calendar(null, {
                sameDay: '[Today] , HH : m',
                nextDay: '[Tomorrow]',
                nextWeek: 'dddd',
                lastDay: '[Yesterday] , HH : mm',
                // lastWeek: '[Last] dddd',
                lastWeek: 'DD MMM , YYYY',
                sameElse: 'DD MMM , YYYY'
              })
            }
          </span>


          <span className='DateTimeText'>
            {/* {item.time} */}
          </span>
        </div>

      </div>



      <div className='PaymentItemRow'>
        <div className='PaymentKey'>Store</div>
        <div className='PaymentValue'>{item.market} </div>
      </div>

      <div className='PaymentItemRow'>
        <div className='PaymentKey'>Token</div>
        <div className='PaymentValue Token' onClick={(e) => copyText(item.token)}>


          {
            item.token.length > 15 ?
              item.token.substring(0, 15) + '...' :
              item.token
          }
          <ContentCopyIcon className='CopyIDOrder' />

        </div>
      </div>

      <Snackbar
        anchorOrigin={{ vertical, horizontal }}
        open={opens}
        onClose={handleClose}
        // message={` Password changed`}
        key={vertical + horizontal}
        autoHideDuration={3000}
        message={<span id="client-snackbar">
          {/* <CheckCircleIcon className='CheckIcon'/> */}
          The token has been copied

        </span>}

      />
    </div>
  )
}

export default PaymentReact